/*
|--------------------------------------------------------------------------
| Site Forms: Newsletter Modal Form
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.siteForms.newsletterModalForm = {
	
	/**
	 * Show form error
	 * @param {object} $form - form dom element
	 */
	"showFormError":function($form){
		var $emailField = $form.find("[name=email]");
		if ($emailField.hasClass("form-error-field")) {return;}
		$form.before('<div class="form-error"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>There was an error processing the form.</div>');
		$emailField.addClass("form-error-field");
	},
	
	
	/**
	 * Remove form error
	 * @param {object} $form - form dom element
	 */
	"removeFormError": function($form){
		$(".modal-newsletter").find(".form-error").remove();
		$form.find("[name=email]").removeClass("form-error-field");
	},
	
	
	/**
	 * Show newsletter modal on delay
	 */
	"showFormWithDelay": function(){
		var thisObject = __gh__webApp.siteForms.newsletterModalForm;
		setTimeout(function(){ 
			thisObject.showForm();
		}, 5000);
	},
	
	
	/**
	 * Show Modal Form
	 */
	"showForm": function(){
		var thisObject 	= __gh__webApp.siteForms.newsletterModalForm,
			baseURL 	= __gh__coreData.siteData.baseURL,
			formURL 	= baseURL +"/section/?template=HTML_newsletter-modal-form";
			
			
		__gh__webApp.utilities.modal.openModal({
			"url": formURL,
			"callback": function(){
				thisObject.bindEvents();
			}
		});
		
	},
	
	
	/**
	 * Submit form
	 * @param {object} $newsletterForm - jquery form element
	 */
	"submitForm": function($newsletterForm){
		
		var thisObject	= __gh__webApp.siteForms.newsletterModalForm,
			baseURL 	= __gh__coreData.siteData.baseURL,
			thankYouURL = baseURL +"/section/?template=HTML_newsletter-modal-form-thank-you",
			trackNewsletterSignUp = __gh__webApp.utilities.tracker.trackNewsletterSignUp;
		
		//Show loading graphic
		$newsletterForm.find("button").html('<i class="fa fa-spinner fa-spin fa-fw"></i>');
		
		//Submit form
		$.post($newsletterForm.attr("action"),$newsletterForm.serialize(),function(response){
			var response 		= JSON.parse(response),
				isSuccessful	= ("success" in response && response.success),
				email 			= $newsletterForm.find("[name=email]").val();
			
			
			if(isSuccessful){
				
				//Replace the modal content area with success message
				__gh__webApp.utilities.fetch.html.get({
					"dom":"#modal-h8f78feh8e7dhsw .modal-inner",
					"url":thankYouURL
				});
				
				trackNewsletterSignUp({
					"email": email
				});
				
				return;
			}
			
			
			//Show an error
			thisObject.showFormError();
		});
	},
	
	
	/**
	 * Validate Email
	 * @param {object} $newsletterForm - jquery form element
	 */
	"validateEmail": function($newsletterForm){
		return /^.+@.+\..+$/.test($newsletterForm.find("[name=email]").val());
	},
	
	
	/**
	 * Bind events
	 */
	"bindEvents": function(){
		var thisObject				= __gh__webApp.siteForms.newsletterModalForm,
			$newsletterForm 		= $("form#newsletter-modal-form");
			
		$newsletterForm.submit(function(event){
			event.preventDefault();
			
			if (thisObject.validateEmail($newsletterForm)){
				thisObject.removeFormError($newsletterForm);
				thisObject.submitForm($newsletterForm);
				return;
			}
			
			thisObject.showFormError($newsletterForm,"Enter a valid email address.");
			
		});
	}

};